import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Label, Header } from 'semantic-ui-react';

const ClaimsLabels = ({ claims }) => (
  <Grid.Row columns={1}>
    <Grid.Column>
      <Header>Claims</Header>
      {claims.map(claim => (
        <Link
          key={claim.id}
          to={'/claim/' + claim.id}
          target="_blank"
          rel="noopener"
        >
          <Label> {claim.codeClaim}</Label>
        </Link>
      ))}
    </Grid.Column>
  </Grid.Row>
);

export default ClaimsLabels;



// WEBPACK FOOTER //
// ./src/component/PassengerView/ClaimsLabels.js